const newsletterMapping = {
	/**
	 * This function used to retrieve the Array of Nl Ids along with Titles mapped to a center
	 * if numberOfNls are not defined, by default we are going to get 4 (should not be more than 4)
	 * We can specificy number to get our custom NLs
	 *
	 * ###############################################################################################
	 * eg:
	 * If sample NL Id array is >> [19, 962, 35, 26]
	 * Then the call to getNewsletterList(1007, 2) will return [19, 962]
	 * ###############################################################################################
	 * @param {Number} centerId
	 * @param {Number} numberOfNls
	 * @return {*|Array}
	 */
	getNewsletterList(centerId, numberOfNls) {
		const centerIdArray = this.getNlArray(centerId, numberOfNls);
		const newsLetterArray = [];
		centerIdArray.forEach((nlsId) => {
			newsLetterArray.push(this.getMappingInfo(nlsId));
		});
		return newsLetterArray;
	},

	/**
	 * Newsletter header text should be customized based on the NL Id and we use this mapping to
	 * construct the header text
	 * eg: Sign up for our free Heart Health Newsletter >> here Heart Health comes from below mapping
	 * If we don't have Id listed in below object then will serve default Nl Id (36)
	 * @param {Number} nlId
	 * @return {Object}
	 */
	getMappingInfo(nlId) {
		const nlObject = {
			11: {
				id: 11,
				title: 'Allergies and Asthma',
				imgPath:
					{
						desktop: '/webmd/consumer_assets/site_images/tocs/healthctr/asthma-cropped.jpg',
						mobile: '/webmd/consumer_assets/site_images/amd_modules/newsletter-hover/1/images/allergies-asthma_mobile.jpg',
					},
			},
			12:	{
				id: 12,
				title: 'Arthritis',
				imgPath: {
					desktop: '/webmd/consumer_assets/site_images/tocs/healthctr/FB_Group_Image/arthritis-cropped.jpg',
					mobile: '/webmd/consumer_assets/site_images/amd_modules/newsletter-hover/1/images/arthritis_mobile.jpg',
				},
			},
			13: {
				id: 13,
				title: 'Breast Cancer',
				imgPath: {
					desktop: '/webmd/consumer_assets/site_images/tocs/healthctr/FB_Group_Image/breastcancer-cropped.jpg',
					mobile: '/webmd/consumer_assets/site_images/amd_modules/newsletter-hover/1/images/breast-cancer_mobile.jpg',
				},
			},
			14: {
				id: 14,
				title: 'Cancer',
				imgPath: {
					desktop: '/webmd/consumer_assets/site_images/tocs/healthctr/FB_Group_Image/cancer_cropped.jpg',
					mobile: '/webmd/consumer_assets/site_images/amd_modules/newsletter-hover/1/images/cancer3_mobile.jpg',
				},
			},
			16: {
				id: 16,
				title: 'Cholesterol Management',
				imgPath: {
					desktop: '/webmd/consumer_assets/site_images/tocs/healthctr/FB_Group_Image/cholesterol-cropped.jpg',
					mobile: '/webmd/consumer_assets/site_images/amd_modules/newsletter-hover/1/images/cholesterol_mobile.jpg',
				},
			},
			17: {
				id: 17,
				title: 'Chronic Pain',
				imgPath: {
					desktop: '/webmd/consumer_assets/site_images/tocs/healthctr/chronic-pain-cropped.jpg',
					mobile: '/webmd/consumer_assets/site_images/amd_modules/newsletter-hover/1/images/chronic-pain_mobile.jpg',
				},
			},
			18: {
				id: 18,
				title: 'Diabetes',
				imgPath: {
					desktop: '/webmd/consumer_assets/site_images/tocs/healthctr/FB_Group_Image/diabetes-cropped.jpg',
					mobile: '/webmd/consumer_assets/site_images/amd_modules/newsletter-hover/1/images/diabetes-food-selection_mobile.jpg',
				},
			},
			19: {
				id: 19,
				title: 'Emotional Wellness',
				imgPath: {
					desktop: '/webmd/consumer_assets/site_images/tocs/healthctr/emotional-wellness-cropped.jpg',
					mobile: '/webmd/consumer_assets/site_images/amd_modules/newsletter-hover/1/images/emotional-wellness_mobile.jpg',
				},
			},
			22: {
				id: 22,
				title: 'Digestive Health',
				imgPath: {
					desktop: '/webmd/consumer_assets/site_images/tocs/healthctr/digestive-cropped.jpg',
					mobile: '/webmd/consumer_assets/site_images/amd_modules/newsletter-hover/1/images/digestive-health_mobile.jpg',
				},
			},
			24: {
				id: 24,
				title: 'Heart Health',
				imgPath: {
					desktop: '/webmd/consumer_assets/site_images/tocs/healthctr/FB_Group_Image/hearthealth-cropped.jpg',
					mobile: '/webmd/consumer_assets/site_images/amd_modules/newsletter-hover/1/images/heart-health_mobile.jpg',
				},
			},
			25: {
				id: 25,
				title: 'Hypertension',
			},
			26: {
				id: 26,
				title: "Men's Health",
				imgPath: {
					desktop: '/webmd/consumer_assets/site_images/tocs/healthctr/mens-health-cropped.jpg',
					mobile: '/webmd/consumer_assets/site_images/amd_modules/newsletter-hover/1/images/mens-health-knee_mobile.jpg',
				},
			},
			27: {
				id: 27,
				title: 'Multiple Sclerosis',
				imgPath: {
					desktop: '/webmd/consumer_assets/site_images/tocs/healthctr/FB_Group_Image/multiple-sclerosis-cropped.jpg',
					mobile: '/webmd/consumer_assets/site_images/tocs/healthctr/FB_Group_Image/multiple-sclerosis-cropped.jpg',
				},
			},
			28: {
				id: 28,
				title: "Parenting and Children's Health",
				imgPath: {
					desktop: '/webmd/consumer_assets/site_images/tocs/healthctr/FB_Group_Image/parenting-cropped.jpg',
					mobile: '/webmd/consumer_assets/site_images/tocs/healthctr/FB_Group_Image/parenting-cropped.jpg',
				},
			},
			1228: {
				id: 1228,
				title: 'Rheumatoid Arthritis',
				imgPath: {
					desktop: '/webmd/consumer_assets/site_images/tocs/healthctr/FB_Group_Image/rheumatoid-arthtitis-cropped.jpg',
					mobile: '/webmd/consumer_assets/site_images/amd_modules/newsletter-hover/1/images/ra-wrist_mobile.jpg',
				},
				series: {
					ctaText: 'Tell us which topics you\'re most interested in (optional):',
					ids: [
						{
							id: 1228,
							title: 'Symptoms & Triggers',
						},
						{
							id: 1230,
							title: 'Latest Treatments',
						},
						{
							id: 1232,
							title: 'Living With RA',
						},
					],
				},
			},
			35: {
				id: 35,
				title: "Women's Health",
				imgPath: {
					desktop: '/webmd/consumer_assets/site_images/tocs/healthctr/FB_Group_Image/womens-health-cropped.jpg',
					mobile: '/webmd/consumer_assets/site_images/amd_modules/newsletter-hover/1/images/womens-health-hip_mobile.jpg',
				},
			},
			36: {
				id: 36,
				title: 'WebMD Daily',
				imgPath: {
					desktop: '/webmd/consumer_assets/site_images/tocs/healthctr/FB_Group_Image/daily-cropped.jpg',
					mobile: '/webmd/consumer_assets/site_images/newsletters/overlay/nl-hover-human-germs-mobile.jpg',
				},
			},
			40: {
				id: 40,
				title: 'Healthy Bones',
				imgPath: {
					desktop: '/webmd/consumer_assets/site_images/tocs/healthctr/healthy-bones-cropped.jpg',
					mobile: '/webmd/consumer_assets/site_images/amd_modules/newsletter-hover/1/images/healthy-bones_mobile.jpg',
				},
			},
			44: {
				id: 44,
				title: 'Depression',
				imgPath: {
					desktop: '/webmd/consumer_assets/site_images/tocs/healthctr/FB_Group_Image/depression-cropped.jpg',
					mobile: '/webmd/consumer_assets/site_images/amd_modules/newsletter-hover/1/images/depression_mobile.jpg',
				},
			},
			45: {
				id: 45,
				title: 'Fibromyalgia',
				imgPath: {
					desktop: '/webmd/consumer_assets/site_images/tocs/healthctr/fibromyalgia-cropped.jpg',
					mobile: '/webmd/consumer_assets/site_images/tocs/healthctr/fibromyalgia-cropped.jpg',
				},
			},
			60: {
				id: 60,
				title: "Alzheimer's",
				imgPath: {
					desktop: '/webmd/consumer_assets/site_images/tocs/healthctr/FB_Group_Image/alzheimers-cropped.jpg',
					mobile: '/webmd/consumer_assets/site_images/amd_modules/newsletter-hover/1/images/alzheimers_mobile.jpg',
				},
			},
			61: {
				id: 61,
				title: 'Cold and Flu',
				imgPath: {
					desktop: '/webmd/consumer_assets/site_images/tocs/healthctr/covid-19-cropped.jpg',
					mobile: '/webmd/consumer_assets/site_images/amd_modules/newsletter-hover/1/images/cold-flu_mobile.jpg',
				},
			},
			62: {
				id: 62,
				title: 'Menopause',
			},
			63: {
				id: 63,
				title: 'Oral Health',
				imgPath: {
					desktop: '/webmd/consumer_assets/site_images/amd_modules/newsletter-hover/1/images/oral-health_desktop.jpg',
					mobile: '/webmd/consumer_assets/site_images/amd_modules/newsletter-hover/1/images/oral-health_mobile.jpg',
				},
			},
			66: {
				id: 66,
				title: 'ADDitude’s Free ADHD',
				imgPath: {
					desktop: '/webmd/consumer_assets/site_images/magazine/dashboard/2022/Additude%20_WebMD.jpg',
					mobile: '/webmd/consumer_assets/site_images/magazine/dashboard/2022/Additude%20_WebMD.jpg',
				},

			},
			68: {
				id: 68,
				title: 'Lupus',
				imgPath: {
					desktop: '/webmd/consumer_assets/site_images/article_thumbnails/hpt_toc_redesign/Lupus-Cropped.jpg',
					mobile: '/webmd/consumer_assets/site_images/article_thumbnails/hpt_toc_redesign/Lupus-Cropped.jpg',
				},

			},

			74: {
				id: 74,
				title: 'COPD',
				imgPath: {
					desktop: '/webmd/consumer_assets/site_images/tocs/healthctr/copd-cropped.jpg',
					mobile: '/webmd/consumer_assets/site_images/amd_modules/newsletter-hover/1/images/copd_mobile.jpg',
				},
			},
			77: {
				id: 77,
				title: 'Healthy Cats',
				imgPath: {
					desktop: '/webmd/consumer_assets/site_images/tocs/healthctr/FB_Group_Image/cats-cropped.jpg',
					mobile: '/webmd/consumer_assets/site_images/amd_modules/newsletter-hover/1/images/pets2_mobile.jpg',
				},
			},
			78: {
				id: 78,
				title: 'Healthy Dogs',
				imgPath: {
					desktop: '/webmd/consumer_assets/site_images/tocs/healthctr/FB_Group_Image/dogs-cropped.jpg',
					mobile: '/webmd/consumer_assets/site_images/amd_modules/newsletter-hover/1/images/pets2_mobile.jpg',
				},
			},
			82: {
				id: 82,
				title: 'Alternative Health',
			},
			84: {
				id: 84,
				title: 'Pregnancy and Baby',
				imgPath: {
					desktop: '/webmd/consumer_assets/site_images/tocs/healthctr/FB_Group_Image/parenting-cropped.jpg',
					mobile: '/webmd/consumer_assets/site_images/tocs/healthctr/FB_Group_Image/parenting-cropped.jpg',
				},
			},
			97: {
				id: 97,
				title: 'Eye Health',
				imgPath: {
					desktop: '/webmd/consumer_assets/site_images/tocs/healthctr/FB_Group_Image/eyehealth-cropped.jpg',
					mobile: '/webmd/consumer_assets/site_images/amd_modules/newsletter-hover/1/images/eye-health_mobile.jpg',
				},
			},
			261: {
				id: 261,
				title: 'Your Health Insurance Guide',
			},
			1222: {
				id: 1222,
				title: 'Migraine',
				imgPath: {
					desktop: '/webmd/consumer_assets/site_images/tocs/healthctr/FB_Group_Image/mirgraine-cropped.jpg',
					mobile: '/webmd/consumer_assets/site_images/amd_modules/newsletter-hover/1/images/migraine-skull_mobile.jpg',
				},
				series: {
					ctaText: 'Tell us which topics you\'re most interested in (optional):',
					ids: [
						{
							id: 1222,
							title: 'Symptoms & Triggers',
						},
						{
							id: 1224,
							title: 'Latest Treatments',
						},
						{
							id: 1226,
							title: 'Living With Migraine',
						},
					],
				},
			},
			960: {
				id: 960,
				title: 'Food & Fitness',
				imgPath: {
					desktop: '/webmd/consumer_assets/site_images/tocs/healthctr/FB_Group_Image/food-fitness-cropped.jpg',
					mobile: '/webmd/consumer_assets/site_images/amd_modules/newsletter-hover/1/images/food-fitness_mobile.jpg',
				},
			},
			962: {
				id: 962,
				title: 'Good Health',
				imgPath: {
					desktop: '/webmd/consumer_assets/site_images/tocs/healthctr/FB_Group_Image/goodhealth-cropped.jpg',
					mobile: '/webmd/consumer_assets/site_images/amd_modules/newsletter-hover/1/images/good-health-option_mobile.jpg',
				},
			},
			1006: {
				id: 1006,
				title: 'Navigating Type 2 Diabetes',
				imgPath: {
					desktop: '/webmd/consumer_assets/site_images/tocs/healthctr/FB_Group_Image/diabetes-cropped.jpg',
					mobile: '/webmd/consumer_assets/site_images/amd_modules/newsletter-hover/1/images/diabetes-type2_mobile.jpg',
				},
			},
			1202: {
				id: 1202,
				title: 'Psoriasis',
				imgPath: {
					desktop: '/webmd/consumer_assets/site_images/tocs/healthctr/FB_Group_Image/psoriasis-cropped.jpg',
					mobile: '/webmd/consumer_assets/site_images/amd_modules/newsletter-hover/1/images/psoriasis_mobile.jpg',
				},
			},
			1208: {
				id: 1208,
				title: 'Crohn\'s and Ulcerative Colitis',
				imgPath: {
					desktop: '/webmd/consumer_assets/site_images/tocs/healthctr/FB_Group_Image/crohns-cropped.jpg',
					mobile: '/webmd/consumer_assets/site_images/amd_modules/newsletter-hover/1/images/crohns_uc_mobile.jpg',
				},
			},
			1210: {
				id: 1210,
				title: 'Eczema',
				imgPath: {
					desktop: '/webmd/consumer_assets/site_images/article_thumbnails/hpt_toc_redesign/Eczema-Cropped.jpg',
					mobile: '/webmd/consumer_assets/site_images/article_thumbnails/hpt_toc_redesign/Eczema-Cropped.jpg',
				},
			},
		};

		/*
		 * Few NLs are not having image path mapping. These should use default NL image path.
		 *  NOTE that the Title is going to still come from this mapping only
		 */
		// eslint-disable-next-line
		if (!(nlObject.hasOwnProperty(nlId))) {
			/* eslint-disable no-param-reassign */
			nlId = 36;
			/* eslint-enable no-param-reassign */
		} else if (nlObject[nlId] && nlObject[nlId].imgPath === undefined) {
			nlObject[nlId].imgPath = nlObject[36].imgPath;
		}
		return nlObject[nlId];
	},

	/**
	 * Used to get list of NL IDs mapped to a center
	 * By default it always return 4 NL Ids for a center ID
	 * Non vue version of code has legacy mapping to flat site structure
	 * In this Vue component, we removed that legacy center mapping and only used flat site center Ids
	 *
	 * NOTE:
	 * ###############################################################################################
	 * We are not using topicIds to serve topic specific NLs. These are copied from previous code
	 * If any request of serving topic specific NLs should be mapped here
	 * ################################################################################
	 *
	 * ###############################################################################################
	 * URL: https://www.webmd.com/anxiety-panic/default.htm
	 * 0
	 * For Single newsletters (sample: newsletter overlay)
	 * The first NL Id in the array is assigned as default value
	 * eg:
	 * For a user on anxiety panic center (1007) which has mapping to an array [19, 962, 35, 26]
	 * By default the NL Id is assigned as "19" and header contains 'Emotional Wellness" text
	 *
	 * For Multiple newsletters (sample: right rail module)
	 * Current right rail module have 4 NLs to be displayed by default.
	 * Multiple NL modules will not contain header or sub header. These will be rendered with
	 * checkbox options. User should select at least 1 NL. Each checkbox will be assigned a NL Id
	 * and display title against each checkbox. These titles comes from getMappingInfo function
	 * ###############################################################################################
	 *
	 * ############################  IMPORTANT   #####################################################
	 * The following mappings are validated with Newsletter Team and approved. Any changes to the
	 * mappings should be run through Newsletter team for approvals
	 * ###############################################################################################
	 *
	 * @param {Number} centerId
	 * @param {Number} numOfnls
	 * @return {Object | Array}
	 */
	getNlArray(centerId, numOfnls) {
		// Default array list if any center is not assigned with an array
		let centerIdArray = [36, 35, 26, 960];
		const centerIds = {
			// anxiety panic
			1007: {
				nl: [19, 962, 35, 26],
				topicId: 2951,
			},

			// bipolar disorder
			1013: {
				nl: [19, 44, 35, 26],
				topicId: 4249,
			},

			// sexual conditions
			1102: {
				nl: [962, 35, 26, 36],
			},

			// fibromyalgia
			1043: {
				nl: [45, 17, 35, 26],
				topicId: 1673,
			},

			// osteoarthritis
			1087: {
				nl: [12, 40, 17, 35],
				topicId: 1681,
			},

			// brain
			1018: {
				nl: [19, 35, 26, 36],
				topicId: 1663,
			},

			// food-recipies
			1047: {
				nl: [960, 36, 26, 35],
			},

			// menopause
			1077: {
				nl: [35, 962, 960, 36],
				topicId: 1825,
			},

			// baby
			1096: {
				nl: [84, 28, 35, 26],
			},

			// ibs
			1067: {
				nl: [22, 35, 26, 960],
				topicId: 1820,
			},

			// genital-herpes
			1048: {
				nl: [962, 35, 26, 36],
				topicId: 1814,
			},

			// lupus
			1073: {
				nl: [68, 35, 36, 19],
				topicId: 1823,
			},

			// balance
			1081: {
				nl: [962, 35, 26, 36],
			},

			// cancer
			1022: {
				nl: [14, 13, 962, 35],
				topicId: 2946,
			},

			// children
			1025: {
				nl: [28, 35, 26, 36],
			},

			// sex-relationships
			1101: {
				nl: [962, 35, 26, 36],
			},

			// oral-health
			1085: {
				nl: [962, 35, 26, 36],
				topicId: 4208,
			},

			// stroke
			1108: {
				nl: [962, 25, 26, 35],
				topicId: 3053,
			},

			// women
			1117: {
				nl: [35, 962, 960, 36],
				topicId: 1840,
			},

			// Inflammatory Bowel Disease/Crohn’s
			1119: {
				nl: [1208, 960, 35, 26],
			},

			// hepatitis
			1059: {
				nl: [962, 26, 35, 36],
				topicId: 2947,
			},

			// eye-health
			1042: {
				nl: [97, 35, 26, 82],
				topicId: 4051,
			},

			// Cataracts-eye-health
			1155: {
				nl: [97, 35, 26, 82],
			},

			// AMD-eye-health
			1130: {
				nl: [97, 35, 26, 82],
			},

			// allergies
			1004: {
				nl: [11, 61, 35, 26],
				topicId: 1625,
			},

			// migraines-headaches
			1080: {
				nl: [1222, 35, 26, 36],
				topicId: 1826,
			},

			// lung-cancer
			1071: {
				nl: [14, 74, 36, 962],
				topicId: 1822,
			},

			// hiv-aids
			1060: {
				nl: [962, 26, 36, 35],
				topicId: 1624,
			},

			// epilepsy
			1040: {
				nl: [36, 35, 26, 962],
				topicId: 1812,
			},

			// asthma
			1009: {
				nl: [11, 74, 26, 35],
				topicId: 1660,
			},

			// heart
			1056: {
				nl: [24, 16, 25, 36],
				topicId: 1675,
			},

			// fitness-exercise
			1046: {
				nl: [960, 35, 962, 26],
				topicId: 1676,
			},

			// urinary-incontinence-oab
			1112: {
				nl: [962, 36, 35, 26],
				topicId: 3691,
			},

			// sex
			1103: {
				nl: [962, 35, 26, 36],
			},

			// mental health
			1078: {
				nl: [19, 44, 35, 26],
				topicId: 2950,
			},

			// heart-disease
			1054: {
				nl: [24, 16, 25, 960],
			},

			// back-pain
			1010: {
				nl: [17, 12, 35, 26],
				topicId: 1661,
			},

			// schizophrenia
			1100: {
				nl: [19, 35, 26, 36],
				topicId: 1835,
			},

			// diet
			1115: {
				nl: [960, 962, 26, 35],
			},

			// hypertension-high-blood-pressure
			1063: {
				nl: [25, 24, 16, 35],
				topicId: 1817,
			},

			// binge eating disorder
			1012: {
				nl: [622, 35, 26, 960],
				topicId: 7022,
			},

			// skin-beauty
			1011: {
				nl: [962, 35, 26, 36],
				topicId: 4209,
			},

			// cholesterol-management
			1026: {
				nl: [16, 25, 960, 24],
				topicId: 1809,
			},

			// ibd-crohns-disease
			1066: {
				nl: [1208, 960, 35, 26],
			},

			// depression
			1032: {
				nl: [44, 19, 26, 35],
				views: 2,
			},

			// multiple-sclerosis
			1082: {
				nl: [27, 35, 26, 36],
				topicId: 1827,
			},

			// skin-problems-and-treatments
			1105: {
				nl: [962, 35, 26, 36],
				topicId: 6067,
			},

			// alzheimers
			1005: {
				nl: [60, 962, 35, 26],
				topicId: 1626,
			},

			// diabetes
			1033: {
				nl: [18, 960, 24, 962],
				topicId: 1667,
				views: 2,
			},

			// digestive-disorders
			1035: {
				nl: [22, 960, 35, 26],
			},

			// erectile-dysfunction
			1041: {
				nl: [26, 960, 36, 962],
				topicId: 1818,
			},

			// breast-cancer
			1020: {
				nl: [13, 14, 36, 35],
				topicId: 1662,
			},

			// melanoma-skin-cancer
			1075: {
				nl: [14, 962, 35, 26],
			},

			// heartburn-gerd
			1057: {
				nl: [22, 960, 35, 26],
				topicId: 1815,
			},

			// infertility-and-reproduction
			1065: {
				nl: [962, 35, 26, 36],
				topicId: 1819,
			},

			// osteoporosis
			1088: {
				nl: [40, 960, 17, 35],
				topicId: 1829,
			},

			// prostate-cancer
			1097: {
				nl: [14, 26, 962, 36],
				topicId: 1688,
			},

			// add-adhd
			1001: {
				nl: [66, 84, 962, 36],
				topicId: 3554,
			},

			// men
			1076: {
				nl: [26, 962, 960, 36],
				topicId: 2952,
			},

			// parenting
			1091: {
				nl: [28, 84, 35, 26],
				topicId: 3609,
			},

			// arthritis
			1008: {
				nl: [12, 40, 36, 35],
				topicId: 2945,
			},

			// cold-and-flu
			1029: {
				nl: [61, 11, 35, 26],
				topicId: 4068,
			},

			// sleep-disorders
			1106: {
				nl: [962, 960, 35, 26],
				topicId: 1836,
			},

			// rheumatoid-arthritis
			1098: {
				nl: [1228, 12, 17, 36],
				topicId: 1834,
				views: 2,
			},

			// pain-management
			1090: {
				nl: [17, 35, 26, 36],
				topicId: 1832,
			},

			// ovarian-cancer
			1089: {
				nl: [14, 35, 962, 36],
			},

			// colorectal-cancer
			1030: {
				nl: [14, 26, 35, 36],
			},

			// parkinsons-disease
			1092: {
				nl: [962, 35, 26, 36],
				topicId: 1833,
			},

			// healthy-aging
			1053: {
				nl: [962, 35, 26, 261],
			},

			// Ulcerative Colitis
			1123: {
				nl: [1208, 35, 26, 36],
			},

			// Psoriasis
			1133: {
				nl: [1202, 35, 26, 36],
			},

			// eczema
			1136: {
				nl: [1210, 35, 26, 36],
			},

			// Psoriatic Arthritis
			1161: {
				nl: [1202, 35, 26, 36],
			},

			// parenting/baby
			1162: {
				nl: [84, 28, 35, 26],
			},

			// lung
			1072: {
				nl: [74, 962, 36, 960],
				topicId: 4292,
			},

			// pets
			1165: {
				nl: [78, 77, 84, 36],
			},

			// pets/cats
			1167: {
				nl: [77, 78, 84, 36],
			},

			// pets/dogs
			1166: {
				nl: [78, 77, 84, 36],
				topicId: 1013,
			},

			// healthy living
			13765: {
				nl: [962, 35, 26, 960],
			},
		};
		if (centerIds[centerId]) {
			centerIdArray = centerIds[centerId].nl;
		}

		/**
		 * Default number of Nls are 4 (max). Customize if requested for less than 4 NLs
		 */
		if (numOfnls < 4) {
			centerIdArray = centerIdArray.splice(0, numOfnls);
		}
		return centerIdArray;
	},
};

export default newsletterMapping;
